import { ISSUERS } from '@/constants';
/**
 * Reads localstorage to determine which login service is active for the user.
 */
export const getIssuer = () => {
  return ISSUERS.AUTH0;
};

/**
 * Authentication object
 * @typedef {Object} Authentication
 * @property {boolean} isAuthenticated - Indicates if the stored token is valid
 * @property {string} provider - String that represents if the user was logged with Okta or Auth0
 */

/**
 *
 * @param {Vue} Vue Global object
 * @param {App} app App instance if calling this from any component (this)
 * @returns {Authentication}
 */
export const getAuthentication = async (Vue, app) => {
  // You can call this method from the router or from everywhere in the app.
  // If you call it from the router, you need to access the auth methods from _Vue.prototype_.
  // Otherwise, if you call this function from any component, you need to pass the _this_ instance.
  const App = (Vue ? Vue.prototype : null) || app;

  const isAuthenticated = App.$auth0.isAuthenticated();
  const token = App.$auth0.getIdToken();
  const provider = getIssuer();

  return { provider, isAuthenticated, token };
};



// WEBPACK FOOTER //
// ./src/utils/index.js